import React from 'react';

const GoogleIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_710_15)">
        <path
          d="M15.9687 8.14967C15.9687 7.49416 15.9145 7.01581 15.797 6.51974H8.15892V9.4784H12.6423C12.5519 10.2137 12.0638 11.321 10.9791 12.065L10.9639 12.1641L13.3789 13.9975L13.5462 14.0139C15.0829 12.6231 15.9687 10.5768 15.9687 8.14967Z"
          fill="#4285F4"
        />
        <path
          d="M8.15892 15.945C10.3554 15.945 12.1994 15.2363 13.5462 14.0139L10.9791 12.065C10.2922 12.5345 9.37014 12.8623 8.15892 12.8623C6.00762 12.8623 4.18173 11.4716 3.53085 9.54932L3.43544 9.55726L0.924274 11.4618L0.891434 11.5513C2.22921 14.1556 4.97712 15.945 8.15892 15.945Z"
          fill="#34A853"
        />
        <path
          d="M3.53085 9.5493C3.35911 9.05324 3.25972 8.5217 3.25972 7.97251C3.25972 7.42326 3.35911 6.89177 3.52181 6.39571L3.51726 6.29006L0.974624 4.35492L0.891433 4.3937C0.34007 5.47443 0.0236969 6.68805 0.0236969 7.97251C0.0236969 9.25697 0.34007 10.4705 0.891433 11.5513L3.53085 9.5493Z"
          fill="#FBBC05"
        />
        <path
          d="M8.15892 3.08269C9.68651 3.08269 10.717 3.72934 11.3045 4.26974L13.6005 2.07285C12.1904 0.788397 10.3554 0 8.15892 0C4.97712 0 2.22921 1.78937 0.891434 4.39371L3.52181 6.39573C4.18173 4.47347 6.00762 3.08269 8.15892 3.08269Z"
          fill="#EB4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_710_15">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default GoogleIcon;
